(function () {
  if (window.__productSectionFaq) return;
  window.__productSectionFaq = true;

  function init(root) {
    if (!root || root.dataset.bound === 'true') return;
    var items = Array.prototype.slice.call(root.querySelectorAll('details'));
    if (!items.length) return;
    root.dataset.bound = 'true';
    var lock = false;

    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (lock || !item.open) return;
        lock = true;
        items.forEach(function (other) {
          if (other !== item) other.open = false;
        });
        lock = false;
      });
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-product-section-faq]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
